module.exports = __webpack_public_path__ + "static/0027-9792f480df24942b7685e2806870937c.png";